import type { Account } from '@/types/v2/account';
import axios from '@/lib/v2/axios';
import type { User } from '@/types/v2/user';

export async function getAccount(accountId: string): Promise<Account> {
  const response = await axios.get(`/api/v2/accounts/${accountId}`);
  return response.data;
}

export async function getAccounts(): Promise<{ accounts: Account[] }> {
  const response = await axios.get('/api/v2/accounts?include=owner&sort=-created_at');
  return response.data;
}

export async function getAdministrators(accountId: string): Promise<{ administrators: User[] }> {
  const response = await axios.get(`/api/v2/accounts/${accountId}/administrators`);
  return response.data;
}

export async function getAdministrator(accountId: string, administratorId: string): Promise<{ administrator: User }> {
  const response = await axios.get(`/api/v2/accounts/${accountId}/administrators/${administratorId}`);
  return response.data;
}

// System Users
export async function getSystemUsers(accountId: string): Promise<{ systemUsers: User[] }> {
  const response = await axios.get(`/api/v2/accounts/${accountId}/system-users`);
  return response.data;
}

export async function getSystemUser(accountId: string, userId: string): Promise<{ systemUser: User }> {
  const response = await axios.get(`/api/v2/accounts/${accountId}/system-users/${userId}`);
  return response.data;
}

export async function updateUserAccountRole(
  accountId: string,
  userId: string,
  data: { role_name: string }
): Promise<void> {
  await axios.patch(`/api/v2/accounts/${accountId}/system-users/${userId}/account-role`, data);
}

export async function addUserToCommunity(
  accountId: string,
  userId: string,
  data: { community_id: string; role_name: string; user_title_id?: string }
): Promise<void> {
  await axios.post(`/api/v2/accounts/${accountId}/system-users/${userId}/communities`, data);
}

export async function removeUserFromCommunity(
  accountId: string,
  userId: string,
  communityId: string
): Promise<void> {
  await axios.delete(`/api/v2/accounts/${accountId}/system-users/${userId}/communities/${communityId}`);
}

export async function addUserToUnit(
  accountId: string,
  userId: string,
  data: {
    unit_id: string;
    role_name: string;
    user_title_id?: string;
    move_in_date?: string;
    move_out_date?: string;
  }
): Promise<void> {
  await axios.post(`/api/v2/accounts/${accountId}/system-users/${userId}/units`, data);
}

export async function removeUserFromUnit(
  accountId: string,
  userId: string,
  unitId: string
): Promise<void> {
  await axios.delete(`/api/v2/accounts/${accountId}/system-users/${userId}/units/${unitId}`);
}
